var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-licences"},[(_vm.vehicle)?_c('subscription-licences-list',{attrs:{"vehicle-id":_vm.vehicle.id,"organization-id":_vm.vehicle.organization ? _vm.vehicle.organization.id : null}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }